<template>
    <div class="grid-item no-flex">
        <v-popper
            ref="menu"
            position="bottomEnd"
            @toggle-on="reset"
            :auto-hide="false">
            <div slot="trigger">
                <v-icon-button v-popper-trigger class="inline-s" type="basic">
                    <v-icon icon="placeholders"/>
                    Add Placeholders
                </v-icon-button>
            </div>
            <div class="dropdown" slot="content">
                <div class="dropdown-content dropdown-content-padded">
                    <r-input
                        name="global-search-field"
                        ref="tagSearch"
                        left-icon="search"
                        placeholder="Search"
                        v-popper-trigger
                        v-model="query"
                    />
                </div>
                <div class="dropdown-content" :class="{'is-scrollable': isExpanded}" v-if="!hasQuery">
                    <template v-if="!isExpanded">
                        <div class="dropdown-item"
                             v-for="(item, index) in quickPlaceholders"
                             :key="item.label"
                             @click="addPlaceholder(item)">
                            {{item.label}}
                        </div>
                        <div
                            v-for="(section, sectionIndex) in placeholderIndexes"
                            class="dropdown-item"
                            @click.stop="openSection(sectionIndex)"
                            :key="sectionIndex">{{section.group | unCamelCase}}
                            <v-icon icon="caret-right"/>
                        </div>
                    </template>
                    <template v-else>
                        <div class="dropdown-item" @click.stop="reset">
                            <v-icon icon="caret-left"/>
                            Back
                        </div>
                        <div
                            v-for="(option, optionIndex) in activeSectionOptions()"
                            class="dropdown-item"
                            @click="addPlaceholder(option)"
                            :key="optionIndex">
                            {{option.label}}
                        </div>
                    </template>
                </div>
                <div class="dropdown-content is-scrollable" v-else>
                    <template v-if="hasResults">
                        <div class="dropdown-item" @click="reset">
                            <v-icon icon="caret-left"/>
                            Back
                        </div>
                        <div
                            v-for="(option, optionIndex) in resultOptions"
                            class="dropdown-item"
                            @click="addPlaceholder(option)"
                            :key="optionIndex">
                            {{option.label}}
                        </div>
                    </template>
                    <div class="padding-top-s padding-bottom-s padding-left-default padding-right-default" v-else>
                        <span v-if="typing">Searching...</span>
                        <span v-else>No results.</span>
                    </div>
                </div>
                <div class="dropdown-content dropdown-content-padded text-right">
                    <r-button size="small" @click="close">Close</r-button>
                </div>
            </div>
        </v-popper>
    </div>
</template>

<script>
    import {
        vIcon, vIconButton,
    } from '@/components/form';
    import vPopper from '@/components/v-popper';
    import debounceMixin from '@/mixins/helpers/debounce-mixin';
    import _ from '@/common/helpers';
    import QUICK_PLACEHOLDERS from '@/modules/rules-engine/actions/send-email/quick-placeholders-map';

    export default {
        name: 'add-placeholders',
        mixins: [debounceMixin],
        components: {
            vIcon, vIconButton, vPopper,
        },
        props: {
            /**
             * @type {Array}
             */
            placeholderIndexes: Array,
            isTextActive: Boolean,
        },
        computed: {
            hasQuery() {
                return !_.isBlank(this.query);
            },
            isExpanded() {
                return this.openedSection !== false;
            },
            hasResults() {
                return this.results.length > 0;
            },
            resultOptions() {
                return this.results.map((name) => {
                    const value = `{{${name}}}`;
                    return {
                        label: value,
                        value,
                    };
                });
            },
            quickPlaceholders() {
                return this.placeholderIndexes.reduce((acc, {group}) => {
                    if (QUICK_PLACEHOLDERS[group]) {
                        return acc.concat(...QUICK_PLACEHOLDERS[group]);
                    }
                    return acc;
                }, []);
            },
        },
        data() {
            return {
                query: null,
                openedSection: false,
                results: [],
            };
        },
        methods: {
            debouncedDelegate(query) {
                this.results = this.placeholderIndexes.reduce((result, group) => {
                    const matches = group.indexer.find(query);
                    if (matches) {
                        return result.concat(matches);
                    }
                    return result;
                }, []);
            },
            resetDelegate() {
                this.results = [];
            },
            /**
             * Triggered when a user clicks on one of the categories of
             * placeholders displayed in the popover.
             * @param {Number} index
             */
            openSection(index) {
                this.openedSection = index;
            },
            /**
             * Generate the options available in a section that was opened.
             * @return {{label: string, value: string}[]}
             */
            activeSectionOptions() {
                const {indexer: {index}} = this.placeholderIndexes[this.openedSection];
                return Object.keys(index).map((name) => {
                    const value = `{{${name}}}`;
                    return {
                        label: value,
                        value,
                    };
                });
            },
            /**
             * Add the selected placeholder tag to the content and reset.
             * @param item
             */
            addPlaceholder(item) {
                this.$emit('add-placeholder', {
                    content: item.textFallbackValue && this.isTextActive
                        ? item.textFallbackValue
                        : item.value,
                });
                this.reset();
                this.close();
            },
            close() {
                this.$refs.menu.$emit('request-popper-hide');
            },
            reset() {
                this.openSection(false);
                this.query = null;
            },
        },
    };
</script>

<style scoped>

</style>
